import { boundedNeed } from "../../lib/coverage";

export type ComparisonMonths = 1 | 3;

export type TrendMonths = 3 | 6 | 12;

export function offsetMonth(month: string, offset: number): string {
  const [year, number] = month.split("-").map(Number);
  const date = new Date(Date.UTC(year, number - 1 + offset, 1));
  return date.toISOString().slice(0, 7);
}

export const monthDays = (month: string): number => {
  const [year, number] = month.split("-").map(Number);
  return new Date(Date.UTC(year, number, 0)).getUTCDate();
};

export const monthLabel = (month: string, short = false): string =>
  new Date(`${month}-01T12:00:00Z`).toLocaleDateString("en-GB", { month: short ? "short" : "long", year: "numeric", timeZone: "UTC" });

/** Only elapsed dates count. An unfinished month compares to the same days last month. */
export function insightPeriod(month: string, today: string) {
  const previousMonth = offsetMonth(month, -1);
  const current = month === today.slice(0, 7);
  const elapsedDays = month > today.slice(0, 7) ? 0 : current ? Number(today.slice(8, 10)) : monthDays(month);
  const previousDays = elapsedDays === 0 ? 0 : current ? Math.min(elapsedDays, monthDays(previousMonth)) : monthDays(previousMonth);
  return {
    month, previousMonth, current, elapsedDays, previousDays,
    end: `${month}-${String(elapsedDays).padStart(2, "0")}`,
    previousEnd: `${previousMonth}-${String(previousDays).padStart(2, "0")}`,
    comparisonLabel: current ? `Compared with 1–${previousDays} ${monthLabel(previousMonth, true)}` : `Compared with ${monthLabel(previousMonth)}`,
  };
}

/** Monthly summaries need the chosen trend window, which also contains last month. */
export const insightNeed = (month: string, months: TrendMonths, comparison: ComparisonMonths = 1): string =>
  boundedNeed(offsetMonth(month, -Math.max(months - 1, comparison)), month);
